import { AxiosError } from "axios";
import instance from "../middleware/HTTPInterceptors";
import ErrorResponse from "../utilities/ErrorResponse";
import { getAuthHeader } from "../utilities/helperFunctions";

interface ApiErrorData {
  message?: string;
  error?: string;
}

function getError(err: unknown): ErrorResponse {
  if (err instanceof AxiosError) {
    const data = err.response?.data as ApiErrorData | undefined;
    return new ErrorResponse(
      data?.message || err.message || "Request failed",
      err.response?.status || 500
    );
  }
  if (err instanceof Error) {
    return new ErrorResponse(err.message || "Request failed", 500);
  }
  return new ErrorResponse("Request failed", 500);
}

export async function apiGet<T>(url: string, params?: Record<string, unknown>): Promise<T> {
  try {
    const config: { headers: Record<string, string>; params?: Record<string, unknown> } = {
      headers: await getAuthHeader(),
    };
    if (params) config.params = params;

    const res = await instance.get(url, config);
    return res.data;
  } catch (err: unknown) {
    throw getError(err);
  }
}

export async function apiPost<T>(url: string, body: unknown = {}): Promise<T> {
  try {
    const config = { headers: await getAuthHeader() };
    const res = await instance.post(url, body, config);
    return res.data;
  } catch (err: unknown) {
    throw getError(err);
  }
}

export async function apiPut<T>(url: string, body: unknown = {}): Promise<T> {
  try {
    const config = { headers: await getAuthHeader() };
    const res = await instance.put(url, body, config);
    return res.data;
  } catch (err: unknown) {
    throw getError(err);
  }
}

export async function apiPatch<T>(url: string, body: unknown = {}): Promise<T> {
  try {
    const config = { headers: await getAuthHeader() };
    const res = await instance.patch(url, body, config);
    return res.data;
  } catch (err: unknown) {
    throw getError(err);
  }
}

export async function apiGetBlob(url: string): Promise<ArrayBuffer> {
  try {
    const config = {
      headers: await getAuthHeader(),
      responseType: "arraybuffer" as const,
    };
    const res = await instance.get(url, config);
    return res.data;
  } catch (err: unknown) {
    throw getError(err);
  }
}

export async function apiDelete<T>(url: string): Promise<T> {
  try {
    const config = { headers: await getAuthHeader() };
    const res = await instance.delete(url, config);
    return res.data;
  } catch (err: unknown) {
    throw getError(err);
  }
}
